import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Divider, Spin, Empty, Modal } from 'antd';
import ReactPlayer from 'react-player/youtube';
import { useIntl } from 'react-intl';
import { loginModalOpen } from '../../../../actions/Login/login.action';
import SettingLesson from './settingLesson';

import { academyAPI } from '../../../../API/academy.api';

import { academyConst } from '../academy';//eslint-disable-line
import CustomLayout from './layout';//eslint-disable-line

import PDFViewer from './pdfViewer';

import {
  isAllLessonsFinished,
  saveNotFinishedLessons,
  getNotFinishedTime,
  deleteFromNotFinishedLessons,
  isItemFinished,
} from '../functions';
import { generateCertificate } from './certificate';

const { confirm } = Modal;

function percentage(partialValue, totalValue) {
  return (100 * partialValue) / totalValue;
}

const YoutubeComponent = ({
  state,
  changeState,
  changeStateWithSave,
  percent,
  setPercent,
  currentTime,
  setCurrentTime,
  lists,
  lessons,
  setLessons,
}) => {
  const {
    activeLesson = {},
    edit,
    width,
    height,
    timeOfNotFinishedLessons,
    activeLessonKey,
  } = state;

  const [inputValue, setInputValue] = useState('');
  const [videoIdCode, setVideoIdCode] = useState(activeLesson.video_id);
  const [loading, setLoading] = useState(false);
  const [err, setError] = useState(false);
  const [onPause, setOnPause] = useState(false);
  const [displayLayout, setDisplayLayout] = useState(false);
  const [pdfId, setPdfId] = useState(null);
  const [generateProccess, setGenerateProcess] = useState(false);
  const [cerIdByListId, setCerIdByListId] = useState({});
  const [startTime, setStartTime] = useState(0);
  const [play, setPlay] = useState(false);
  const intl = useIntl();
  const { user, isLoggedIn } = useSelector((store) => store.authentication);
  const dispatch = useDispatch();

  const leavePageMessage = intl.formatMessage({
    id: 'Changes may not be saved',
    defaultMessage: 'Changes may not be saved',
  });

  useEffect(() => {
    changeState({
      certificateIdByListId: [...state.certificateIdByListId, cerIdByListId],
    });
  }, [cerIdByListId]);

  useEffect(() => {
    setStartTime(0);
    setVideoIdCode(activeLesson.video_id);
    timeOfNotFinishedLessons.forEach((item) => {
      if (item.id === activeLesson.id) {
        setStartTime(item.time);
        setCurrentTime(item.time);
        setPercent(item.percent);
      }
    });
    if (activeLesson.id === 'last') {
      state.certificateIdByListId.forEach((item) => {
        if (item.list_id === state.activeListKey) {
          setPdfId(item.certificate_id);
        }
      });
    }
    setOnPause(false);
    setPlay(false);
  }, [activeLesson]);

  const isWindowSmall = () =>
    width === '100%' && height === '100%'
      ? false
      : parseInt(width) < 480 || parseInt(height) < 320;

  useEffect(() => {
    if (!isWindowSmall()) {
      setDisplayLayout(onPause);
    }
  }, [onPause]);

  useEffect(() => {
    if (isWindowSmall()) {
      setDisplayLayout(false);
    } else {
      setDisplayLayout(onPause);
    }
  }, [width, height]);

  useEffect(() => {
    if (play) {
      window.onbeforeunload = (event) => {
        const message = leavePageMessage;
        const e = event || window.event;
        // For IE and Firefox
        if (e) {
          e.returnValue = message;
        }

        // For Safari
        return message;
      };
    } else {
      window.onbeforeunload = null;
    }
  }, [play]);

  const deleteLesson = () => {
    confirm({
      title: intl.formatMessage({
        id: 'Delete lesson?',
        defaultMessage: 'Delete lesson?',
      }),
      okText: intl.formatMessage({ id: 'Yes', defaultMessage: 'Yes' }),
      okType: 'danger',
      cancelText: intl.formatMessage({ id: 'No', defaultMessage: 'No' }),
      onOk() {
        const data = { ...state.activeLesson };
        data.deleted = 1;

        academyAPI
          .save(data)
          .then((res) => console.log(res))
          .catch((err) => console.log(err));

        const index = lessons.findIndex((x) => x.id === data.id);
        const newLessons = [...lessons];
        newLessons.splice(index, 1);

        let activeLesson = {};

        if (newLessons.length > 0) {
          const newIndex = index > 0 ? index - 1 : index;
          activeLesson = newLessons[newIndex];
        }

        setLessons([...newLessons]);

        changeStateWithSave({
          activeLesson: { ...activeLesson },
        });
      },
      onCancel() {
        return null;
      },
    });
  };

  const changeTitle = () => {
    changeState({
      modalShow: true,
      type: academyConst.LESSON,
      action: academyConst.EDIT,
    });
  };

  const _onReady = (e) => {
    if (
      !activeLesson.video_id ||
      activeLesson.video_duration === 0 ||
      activeLesson.video_id !== videoIdCode
    ) {
      const data = { ...activeLesson };
      data.video_id = videoIdCode;
      data.video_duration = e.getDuration();

      academyAPI
        .save(data)
        .then((res) => console.log(res))
        .catch((err) => console.log(err));

      const index = lessons.findIndex((x) => x.id === data.id);
      const newLessons = [...lessons];
      newLessons.splice(index, 1, data);

      setLessons([...newLessons]);

      changeStateWithSave({
        activeLesson: { ...data },
      });
    }
  };

  const _onProgress = (e) => {
    const p = percentage(e.playedSeconds, activeLesson.video_duration);
    if (play) {
      setPercent(p);
      setCurrentTime(e.playedSeconds);
      changeState({
        timeOfNotFinishedLessons: saveNotFinishedLessons(
          timeOfNotFinishedLessons,
          activeLessonKey,
          percent,
          currentTime
        ),
      });
    }
  };

  const _onPlay = () => {
    setPlay(true);
    setTimeout(() => {
      setOnPause(false);
    }, 100);
  };

  const _onPause = () => {
    changeStateWithSave({
      timeOfNotFinishedLessons: saveNotFinishedLessons(
        timeOfNotFinishedLessons,
        activeLessonKey,
        percent,
        currentTime
      ),
    });
    setOnPause(true);
    setPlay(false);
  };

  const getNewActiveLesson = (index, newFinishedLessonsIds) => {
    if (index < lessons.length - 1) {
      if (lessons[index + 1]) {
        return isAllLessonsFinished(lessons, newFinishedLessonsIds);
      }
      const data = { id: 'last' };
      return data;
    }

    return lessons[index];
  };

  const _onEnd = () => {
    setPlay(false);

    const index = lessons.findIndex((x) => x.id === activeLesson.id);
    const newFinishedLessonsIds = state.finishedLessonsIds.includes(
      activeLesson.id
    )
      ? [...state.finishedLessonsIds]
      : [...state.finishedLessonsIds, activeLesson.id];

    const newActiveLessons = getNewActiveLesson(index, newFinishedLessonsIds);

    const newFinishedListIds = isAllLessonsFinished(
      lessons,
      newFinishedLessonsIds
    )
      ? [...state.finishedListIds, state.activeListKey]
      : [...state.finishedListIds];

    const newTimeOfNotFinishedLessons = deleteFromNotFinishedLessons(
      activeLesson,
      timeOfNotFinishedLessons
    );

    changeStateWithSave(
      {
        activeLesson: { ...newActiveLessons },
        activeLessonKey: newActiveLessons.id,
        finishedLessonsIds: [...newFinishedLessonsIds],
        finishedListIds: [...newFinishedListIds],
        timeOfNotFinishedLessons: [...newTimeOfNotFinishedLessons],
      },
      'end'
    );

    setPercent(getNotFinishedTime(newActiveLessons, timeOfNotFinishedLessons));

    if (
      isAllLessonsFinished(lessons, newFinishedLessonsIds) &&
      !isItemFinished(state.activeListKey, state.finishedListIds)
    ) {
      if (isLoggedIn) {
        setGenerateProcess(true);
        const cb = (response) => {
          setPercent(
            getNotFinishedTime(newActiveLessons, timeOfNotFinishedLessons)
          );
          setGenerateProcess(false);
          setPdfId(response);
          setCerIdByListId({
            certificate_id: response,
            list_id: state.activeListKey,
          });
        };
        setTimeout(() => {
          generateCertificate(state, intl, user, cb, lists);
        }, 600);
      } else {
        confirm({
          title: intl.formatMessage({
            id: 'Log in to get your certificate.',
            defaultMessage: 'Log in  to get your certificate.',
          }),
          okText: intl.formatMessage({ id: 'Yes', defaultMessage: 'Yes' }),
          okType: 'danger',
          cancelText: intl.formatMessage({ id: 'No', defaultMessage: 'No' }),
          onOk() {
            dispatch(loginModalOpen(true));
            return null;
          },
          onCancel() {
            return null;
          },
        });
      }
    }
  };

  const _onError = () => {
    setError(true);
  };

  const getComponent = () => {
    if (
      Object.keys(activeLesson).length > 0 &&
      videoIdCode &&
      !loading &&
      !err
    ) {
      return (
        <>
          <ReactPlayer
            key={videoIdCode}
            url={`https://www.youtube.com/watch?v=${videoIdCode}&t=${startTime}s&modestbranding=1`}
            width="100%"
            height="100%"
            onReady={_onReady}
            onPause={_onPause}
            onPlay={_onPlay}
            onError={_onError}
            onEnded={_onEnd}
            onProgress={_onProgress}
            controls
          />
          <CustomLayout
            displayLayout={displayLayout}
            activeLesson={activeLesson}
            lessons={lessons}
            changeState={changeStateWithSave}
            state={state}
            percent={percent}
            setPercent={setPercent}
            currentTime={currentTime}
          />
        </>
      );
    }
    if (loading || generateProccess) {
      return <Spin />;
    }
    if (
      Object.keys(activeLesson).length > 0 &&
      activeLesson.id === 'last' &&
      !generateProccess
    ) {
      return (
        <div className="empty">
          {pdfId ? (
            <PDFViewer id={pdfId} />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({
                id: 'Something went wrong, please refresh the page',
                defaultMessage: 'Something went wrong, please refresh the page',
              })}
            />
          )}
        </div>
      );
    }
    if (err) {
      return (
        <div className="empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={intl.formatMessage({
              id: 'Something went wrong, please refresh the page',
              defaultMessage: 'Something went wrong, please refresh the page',
            })}
          />
        </div>
      );
    }
    if (Object.keys(activeLesson).length === 0) {
      return (
        <div className="empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={intl.formatMessage({
              id: 'Select a lesson to see the video',
              defaultMessage: 'Select a lesson to see the video',
            })}
          />
        </div>
      );
    }
    return (
      <div className="empty">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={intl.formatMessage({
            id: 'No video yet',
            defaultMessage: 'No video yet',
          })}
        />
      </div>
    );
  };

  return (
    <>
      {Object.keys(activeLesson).length > 0 && edit && (
        <>
          <SettingLesson
            setInputValue={setInputValue}
            inputValue={inputValue}
            setVideoIdCode={setVideoIdCode}
            setLoading={setLoading}
            deleteLesson={deleteLesson}
            changeTitle={changeTitle}
            state={state}
            lists={lists}
          />
          <Divider
            orientation="left/right"
            className="divider_academy_lesson"
          />
        </>
      )}
      {getComponent()}
    </>
  );
};

export default YoutubeComponent;
